export const projects = [
    { name: 'Arena 5.1', value: 'arena51' },
    { name: 'Ark.com', value: 'arkcom' },
    { name: 'AARP', value: 'aarp' },
];
